import Sortable from "sortablejs"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.orderDirty = false
    this.boundBeforeUnload = (e) => {
      if (this.orderDirty) {
        e.preventDefault()
        e.returnValue = ""
      }
    }
    window.addEventListener("beforeunload", this.boundBeforeUnload)

    const form = this.element.closest("form")
    if (form) {
      form.addEventListener("submit", () => {
        this.orderDirty = false
      })
    }

    this.sortable = Sortable.create(this.element, {
      handle: ".benefits-sort-handle",
      animation: 150,
      onEnd: () => {
        this.orderDirty = true
      },
    })
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.boundBeforeUnload)
    if (this.sortable) {
      this.sortable.destroy()
    }
  }
}
